import Icon from "@mdi/react";
import { EditEvent, EventPreview, useEvents } from "../components/Event";
import { useHead } from "../services/common";
import { useUser } from "../User";
import { mdiPlus } from "@mdi/js";
import { useMemo, useState } from "react";
import { Loading } from "../components";
import { groupBy, uniq } from "lodash";
import moment from "moment";

export default function Events() {

    useHead({
        title: "Akce a události | T.J. Sokol Poniklá – Kalendář akcí",
        description: "Přehled aktuálních i plánovaných akcí pořádaných T.J. Sokol Poniklá. Sportovní turnaje, kulturní večery, dětské dny a další. Nenechte si nic ujít!"
    });

    const user = useUser();

    const [addEvent, setAddEvent] = useState(false);

    const [events, error, isLoading, reload] = useEvents();

    const groups = useMemo(() => {
        if (!events) return [moment().format("YYYY")];

        return uniq(Object.keys(groupBy(events, event => moment(event.dateFrom).format("YYYY"))))
            .sort()
            .reverse();
    }, [events]);

    const [activeGroup, setActiveGroup] = useState(groups[0]);

    const showEvents = (events || [])
        .filter(event => moment(event.dateFrom).format("YYYY") === activeGroup)
        .sort((a, b) => b.dateFrom.localeCompare(a.dateFrom));

    return <>
        <div className="header">
            <h1>Akce</h1>
        </div>
        <section className="width-max">
            {(user.isEditor || user.isAdmin) && <div className="admin">
                <button onClick={() => setAddEvent(true)}><Icon path={mdiPlus} size={1} /> Přidat akci</button>
                <EditEvent show={addEvent} onClose={() => setAddEvent(false)} onChange={reload} />
            </div>}

            {isLoading && <Loading />}
            {error && <p className="alert">Akce se nepodařilo načíst. Zkuste to prosím později.</p>}
            {events && <>
                {showEvents.length === 0 && <p className="info">Zatím zde nejsou žádné akce.</p>}
                <div className="button-select width-max">
                    {groups.map(group => <button key={group} className={activeGroup === group ? "active" : ""} onClick={() => setActiveGroup(group)}>{group}</button>)}
                </div>
                <div className="grid">
                    {showEvents.map(event => <EventPreview key={event._id} event={event} onChange={reload} />)}
                </div>
            </>}
        </section>
    </>;
}